module.exports = __webpack_public_path__ + "img/food.9d2b80e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/food.jpg
// module id = rs7W
// module chunks = 0